module.exports = __webpack_public_path__ + "media/win.e4fb02c7.wav";